import { CREATE_TICKET, SEARCH_USER, USER_ROLE_DROPDOWN, SAVE_EXTERNAL_USER, EXTERNAL_USER_LIST } from "./type";

const initalState = {
    createTicketRes: null,
    searchUser: [],
    getUserBasedDropdown: [],
    insertExternalUser: [],
    getExternalUserData: []
};

const createTicketReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CREATE_TICKET:
            return {
                ...state,
                createTicketRes: payload,
            };
        case SEARCH_USER:
            return {
                ...state,
                searchUser: payload,
            };
        case USER_ROLE_DROPDOWN:
            return {
                ...state,
                getUserBasedDropdown: payload,
            };
        case SAVE_EXTERNAL_USER:
            return {
                ...state,
                insertExternalUser: payload,
            };
        case EXTERNAL_USER_LIST:
            return {
                ...state,
                getExternalUserData: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default createTicketReducer;
